export default __webpack_public_path__ + "static/media/trash.9b3e626a.svg";